<template>
  <div class="collapse-control notification-collapse-narrow" :class="['notification-group-collapsible-'+groupKey, disableControl ? 'disabled-collapse' : '']" @click="toggle" v-b-toggle="disableControl ? null : 'notification-group-collapse-'+groupKey" :style="disableControl ? { pointerEvents: 'none', opacity: 0.5 } : {}">
    <div class="task-exp">
      <span v-if="!expanded">
        <span class="notification-count">+{{ unreadCount }} New</span>
        <span class="icon">
          <img src="@/csmworkflow/img/chevron-down.svg" />
        </span>
      </span>
      <span v-else>
        <span class="notification-close-text">CLOSE</span>
        <span class="icon close-collase">
          <img src="@/csmworkflow/img/chevron-up.svg" />
        </span>
      </span>
    </div>
    <div class="task-exp exp-mobile">
      <span v-if="!expanded">
        <span class="icon">
          <img src="@/csmworkflow/img/chevron-down.svg" />
        </span>
      </span>
      <span v-else>
        <span>
          <span class="icon close-collase">
            <img src="@/csmworkflow/img/chevron-up.svg" />
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notifications: { type: Array, default: () => [] },
    groupKey: { type: String, required: true },
    expandAll: { type: Boolean, default: false },
    totalCount: { type: [Number, String], default: null },
    unreadTotal: { type: [Number, String], default: null },
    disabled: { type: Boolean, default: false },
    hasHeaderPreview: { type: Boolean, default: true }
  },
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    unreadCount() {
      // Total unread for the group (includes the top/preview notification)
      if (this.unreadTotal !== undefined && this.unreadTotal !== null) {
        return this.unreadTotal;
      }
      return this.countUnread(this.notifications);
    },
    extraCount() {
      const headerCount = this.hasHeaderPreview === false ? 0 : 1;
      // Use totalCount if provided (for grouped alerts with load more), otherwise use notifications.length
      const total = this.totalCount !== undefined && this.totalCount !== null ? this.totalCount : (this.notifications || []).length;
      return Math.max(total - headerCount, 0); // When there is a header preview, subtract 1.
    },
    disableControl() {
      // Disable only when there is nothing to collapse
      return this.extraCount <= 0;
    }
  },
  methods: {
    countUnread(list) {
      return (list || []).filter(alert => alert.status === 0).length;
    },
    toggle() {
      if (this.disableControl) {
        return;
      }
      this.expanded = !this.expanded;
    }
  },
  mounted() {
    this.$root.$on("bv::collapse::state", (id, state) => {
      if (id == ('notification-group-collapse-'+this.groupKey)) {
        this.expanded = state;
      }
    })
  },
  watch: {
    expandAll: function(newVal, oldVal) {
      this.expanded = newVal;
    },
  }
};
</script>

<style>
.notification-collapse-narrow {
  max-width: 120px;
  min-width: 60px;
}

.notification-collapse-narrow .task-exp {
  padding: 5px 10px;
}

.notification-count {
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  white-space: nowrap;
}

.notification-close-text {
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  white-space: nowrap;
  margin-right: 5px;
}

.notification-collapse-narrow .icon img {
  width: 12px;
  height: 12px;
}
</style>
